 <template>
  <div>
    <div class="title">Payment Breakdown as of {{ dateAtSelected }}</div>
    <div class="remaining output">
      <div class="item">
        <div class="key"></div>
        <div class="label">Remaining Balance</div>
      </div>

      <div class="value">{{ balanceAtSelected }}</div>
    </div>
    <div class="principle output">
      <div class="item">
        <div class="key"></div>
        <div class="label">Principle</div>
      </div>

      <div class="value">{{ paidPrincipleAtSelected }}</div>
    </div>
    <div class="interest output">
      <div class="item">
        <div class="key"></div>
        <div class="label">Interest</div>
      </div>
      <div class="value">{{ interestAtSelected }}</div>
    </div>
  </div>
</template>

<script>
import Moment from "moment";
import {
  paidPrincipleByPaymentNumber,
  totalInterestAfterNumPayments,
  principleByPaymentNumber
} from "../util/formula";
import { mapState, mapMutations, mapGetters } from "vuex";
import { STATE, MUTATIONS, GETTERS } from "../storeConstants";
import { currency } from "../util/format";

const { PAYMENT } = GETTERS;

export default {
  methods: {
    currency: currency,
    paidPrinciple: paidPrincipleByPaymentNumber,
    paidInterest: totalInterestAfterNumPayments,
    remainingPrinciple: principleByPaymentNumber
  },
  computed: {
    ...mapState({
      state: state => state.base
    }),
    ...mapGetters([PAYMENT]),
    balanceAtSelected() {
      return this.currency(
        this.state.PAYMENT_DATA[this.state.CHART_SELECTOR_SNAP_X].balance
      );
    },
    interestAtSelected() {
      return this.currency(
        this.state.PAYMENT_DATA[this.state.CHART_SELECTOR_SNAP_X].interest
      );
    },
    paidPrincipleAtSelected() {
      return this.currency(
        this.state.PAYMENT_DATA[this.state.CHART_SELECTOR_SNAP_X].principle
      );
    },
    dateAtSelected() {
      return Moment(this.state.START_DATE)
        .add(this.state.CHART_SELECTOR_SNAP_X, "months")
        .format("MMM DD, YYYY");
    }
  }
};
</script>
<style scoped lang="scss">
.amortization-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > * {
    left: -2px;
    position: relative;
  }
}
.item {
  display: flex;
  align-items: center;
}
.title {
  font-size: 16px;
  font-weight: 700;
  font-family: sans-serif;
  margin-bottom: 20px;
}
.label,
.value {
  font-size: 14px;
  font-family: sans-serif;
}
.label {
  margin-left: 16px;
}

.output {
  width: 100%;
  justify-content: space-between;
  border-top: solid #e3e3e3 1px;
  &:last-child {
    border-bottom: solid #e3e3e3 1px;
  }

  display: flex;
  align-items: center;
  height: 50px;
}
.value {
  font-weight: 700;
}
.key {
  height: 28px;
  width: 13px;
}
.remaining {
  .key {
    background-color: #acd14d;
  }
}
.principle {
  .key {
    background-color: #62c5b4;
  }
}
.interest {
  .key {
    background-color: rgb(114, 135, 161, 0.8);
  }
}
</style>